<div class="row">
  <div class="col-12 justify-content-end d-flex mb-10">
    <div class="d-inline-block width-235px text-right" style="z-index: 1">
      <div class="row">
        <div class="col-2">
          <button
            type="button"
            class="btn-danger btn-round"
            [ngClass]="{ refreshing: isRefreshing }"
            [(ngModel)]="isButtonDisabled"
            (click)="reloadAllAlert()"
          >
            <i class="fn-global-refresh font-20"></i>
          </button>
        </div>
        <div class="col-8">
          <fn-select [labelKey]="'name'" [inputKey]="'name'" [optionList]="teamArray" (changeEvent)="filterAlert()"
                [placeholder]="'Select Team'" [(ngModel)]="selectTeam" appendTo="body"
                [ngModelOptions]="{ standalone: true }">
              </fn-select>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="row">
      <div class="col-12 alert-wrapper">
        <table width="100%">
          <colgroup>
            <col style="width: calc(100% - 150px)" />
            <col style="width: 150px" />
          </colgroup>
          <tr>
            <td valign="top" style="vertical-align: top; min-height: 102px">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-2 totalAlerts">
                      <div
                        class="alert-card element-style"
                        (click)="openTotal()"
                      >
                        <mat-progress-bar
                          mode="indeterminate"
                          *ngIf="isLoadMain"
                          class="custom-progress-bar gray_bar"
                        ></mat-progress-bar>
                        <div class="describe">
                          <div class="value red">
                            {{ totalAlerts
                            }}<i
                              class="fn-global-refresh white ml-10 font-20 cursor-pointer"
                              (click)="getTotalCount($event)"
                            ></i>
                          </div>
                          <div class="description semiBold">Total Alerts</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-10">
                      <div class="alert-wrap-inner">
                        <div
                          class="alert-card inner"
                          (click)="loadAlertSev('Sev 1')"
                        >
                          <mat-progress-bar
                            mode="indeterminate"
                            *ngIf="isLoading1"
                            class="custom-progress-bar"
                          ></mat-progress-bar>
                          <div class="row describe">
                            <div class="d-flex gap-2">
                              <div
                                class="value"
                                sev1-title="Total / Not Acknowledged"
                              >
                                {{ sev1.total }}/{{ sev1.notViewed }}
                              </div>
                              <div class="m-0">
                                <i
                                  class="fn-global-refresh white font-20"
                                  (click)="getSevCount('Sev 1', $event)"
                                ></i>
                              </div>
                            </div>
                            <div class="description semiBold">Sev 1</div>
                          </div>
                          <div>
                            <img
                              src="https://agcdn.altametrics.com/hw_prod_others/common/images/ats/images/Severity_High.svg"
                              alt=""
                              srcset=""
                            />
                          </div>
                        </div>
                        <div
                          class="alert-card inner"
                          (click)="loadAlertSev('Sev 2')"
                        >
                          <mat-progress-bar
                            mode="indeterminate"
                            *ngIf="isLoading2"
                            class="custom-progress-bar"
                          ></mat-progress-bar>
                          <div class="row describe">
                            <div class="d-flex gap-2">
                              <div
                                class="value"
                                sev2-title="Total / Not Acknowledged"
                              >
                                {{ sev2.total }}/{{ sev2.notViewed }}
                              </div>
                              <div class="m-0">
                                <i
                                  class="fn-global-refresh white font-20"
                                  (click)="getSevCount('Sev 2', $event)"
                                ></i>
                              </div>
                            </div>
                            <div class="description semiBold">Sev 2</div>
                          </div>
                          <div>
                            <img
                              src="https://agcdn.altametrics.com/hw_prod_others/common/images/ats/images/Severity_Medium.svg"
                              alt=""
                              srcset=""
                            />
                          </div>
                        </div>
                        <div
                          class="alert-card inner"
                          (click)="loadAlertSev('Sev 3')"
                        >
                          <mat-progress-bar
                            mode="indeterminate"
                            *ngIf="isLoading3"
                            class="custom-progress-bar"
                          ></mat-progress-bar>
                          <div class="row describe">
                            <div class="d-flex gap-2">
                              <div
                                class="value"
                                sev3-title="Total / Not Acknowledged"
                              >
                                {{ sev3.total }}/{{ sev3.notViewed }}
                              </div>
                              <div class="m-0">
                                <i
                                  class="fn-global-refresh white font-20"
                                  (click)="getSevCount('Sev 3', $event)"
                                ></i>
                              </div>
                            </div>
                            <div class="description semiBold">Sev 3</div>
                          </div>
                          <div>
                            <img
                              src="https://agcdn.altametrics.com/hw_prod_others/common/images/ats/images/Severity_Low.svg"
                              alt=""
                              srcset=""
                            />
                          </div>
                        </div>
                        <div class="alert-card dis" (click)="disabledAlerts()">
                          <div
                            class="d-flex justify-content-between align-items-center w-100"
                          >
                            <div class="row">
                              <div class="value" dis-title="Disabled Alert">
                                {{ disabled }}
                              </div>
                              <div class="description">Disabled</div>
                            </div>
                            <div class="min-height d-flex gap-2">
                              <img
                                src="assets/images/min_dis.png"
                                alt=""
                                srcset=""
                                style="height: 35px; width: 35px"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td
              class="align-top"
              style="min-height: 102px"
              [attr.rowspan]="tableSize ? 2 : 1"
              rowspan="2"
            >
              <div class="row ml-0">
                <div
                  class="col-12 esclation width-150px"
                  [ngClass]="tableSize ? 'escalation-open' : 'h-auto'"
                >
                  <div class="alert-card element-styleChange">
                    <div class="describe w-100 text-center">
                      <p class="m-0 font-18 semiBold">Forwarded</p>
                      <div
                        class="esclate-icon cursor-pointer"
                        *ngIf="!tableSize"
                        (click)="openEsc()"
                      >
                        <i class="cursor-pointer fn-global-down rotate-270"></i>
                      </div>
                      <div
                        class="esclate-icon cursor-pointer"
                        *ngIf="tableSize"
                        (click)="closeEsc()"
                      >
                        <i
                          class="cursor-pointer fn-global-times font-weight-600"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="w-100"
                      [ngClass]="tableSize ? 'd-block' : 'd-none'"
                    >
                      <div class="alert-wrapper esclate-wrap full-height">
                        <div
                          class="alert-card bg-light-red"
                          (click)="openEscSev('Sev 1')"
                        >
                          <div>
                            <img
                              src="https://agcdn.altametrics.com/hw_prod_others/common/images/ats/images/Sev_High.svg"
                              alt=""
                              srcset=""
                            />
                          </div>
                          <div class="description semiBold">Sev 1</div>
                          <div class="value">{{ sev1.escalated }}</div>
                        </div>
                        <div
                          class="alert-card bg-light-orange"
                          (click)="openEscSev('Sev 2')"
                        >
                          <div>
                            <img
                              src="https://agcdn.altametrics.com/hw_prod_others/common/images/ats/images/Sev_Medium.svg"
                              alt=""
                              srcset=""
                            />
                          </div>
                          <div class="description semiBold">Sev 2</div>
                          <div class="value">{{ sev2.escalated }}</div>
                        </div>
                        <div
                          class="alert-card bg-light-blue"
                          (click)="openEscSev('Sev 3')"
                        >
                          <div>
                            <img
                              src="https://agcdn.altametrics.com/hw_prod_others/common/images/ats/images/Sev_Low.svg"
                              alt=""
                              srcset=""
                            />
                          </div>
                          <div class="description semiBold">Sev 3</div>
                          <div class="value">{{ sev3.escalated }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td
              class="align-top"
              [ngClass]="tableSize ? 'w-100' : ''"
              [attr.colspan]="tableSize ? 1 : 2"
            >
              <div class="hw-box-content">
                <div class="hw-header-wrap">
                  <div class="row">
                    <div class="col-4 fw-bold fs-5">{{ currentPage }}</div>
                    <div class="col-4 text-center servity-filter">
                      <fn-event-check-box-filter
                        [eventFilterArray]="eventCheckboxFilterArray"
                        (actionOnFilter)="filterEventCheckboxData($event)"
                        
                      >
                      </fn-event-check-box-filter>
                    </div>
                    <div class="col-4 text-end" style="z-index: 0">
                      <label
                        class="label cursor-pointer align-middle mb-0 ml-5"
                      >
                        <fn-table-search
                          (search)="searchOnRows($event)"
                          (closeSearch)="closeSearch()"
                        >
                        </fn-table-search>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="hw-content" style="height: calc(100vh - 283px)">
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-bordered fixed-layout m-0">
                        <colgroup>
                          <col style="width: 2%" />
                          <col style="width: 5%" />
                          <col style="width: 7%" />
                          <col style="width: 5%" />
                          <col style="width: 7%" />
                          <col style="width: 17%" />
                          <col style="width: 7%" />
                          <col style="width: 7%" />
                          <col style="width: 3%" />
                          <col style="width: 5%" />
                          <col style="width: 7%" />
                          <col style="width: 5%" />
                          <col style="width: 4%" />
                          <col style="width: 7%" />
                          <col style="width: 8%" />
                          <col style="width: 4%" />
                        </colgroup>
                        <thead>
                          <tr>
                            <td class="text-center">
                              <div
                                class="d-flex align-items-center"
                                style="color: var(--body-textColor) !important"
                              >
                                <fn-checkbox
                                  class="mt-3"
                                  [(ngModel)]="isAllSelected"
                                  (change)="toggleSelectAll($event)"
                                ></fn-checkbox>
                                All
                              </div>
                            </td>
                            <th class="text-center">Alert ID</th>
                            <th class="text-center">Alert Time</th>
                            <th class="text-center">Severity</th>
                            <th class="text-center">Product</th>
                            <th class="text-center">Alert</th>
                            <th class="text-center">Source Info</th>
                            <th class="text-center">Sender</th>
                            <th class="text-center">Count</th>
                            <th class="text-center">Duration</th>
                            <th class="text-center">Last Update</th>
                            <th class="text-center">Ack By</th>
                            <th class="text-center">Escalated</th>
                            <th class="text-center">Last Action At</th>
                            <th class="text-center">Recent Comment</th>
                            <th class="text-center">Action</th>
                          </tr>
                        </thead>
                      </table>
                      <div
                        style="
                          max-height: calc(100vh - 380px);
                          overflow-y: auto;
                        "
                      >
                        <table
                          class="table table-bordered table-striped table-hover fixed-layout m-0"
                        >
                          <colgroup>
                            <col style="width: 2%" />
                            <col style="width: 5%" />
                            <col style="width: 7%" />
                            <col style="width: 5%" />
                            <col style="width: 7%" />
                            <col style="width: 17%" />
                            <col style="width: 7%" />
                            <col style="width: 7%" />
                            <col style="width: 3%" />
                            <col style="width: 5%" />
                            <col style="width: 7%" />
                            <col style="width: 5%" />
                            <col style="width: 4%" />
                            <col style="width: 7%" />
                            <col style="width: 8%" />
                            <col style="width: 4%" />
                          </colgroup>
                          <tbody>
                            <tr
                              *ngFor="let row of newFilterData; let i = index"
                            >
                              <td
                                class="text-center"
                                [ngClass]="{ forwarded: row.forwarded }"
                                [style.background-color]="
                                  row.forwarded ? getForwardedColor() : ''
                                "
                              >
                                <fn-checkbox
                                  [(ngModel)]="row.isSelected"
                                  (change)="
                                    toggleRowSelection($event, row.primaryKey)
                                  "
                                  [value]="row.primaryKey"
                                ></fn-checkbox>
                              </td>
                              <td
                                class="text-truncate"
                                title="{{ row.alertID }}"
                                (dblclick)="copyData(row.alertID)"
                                style="color: var(--blue) !important"
                                container="body"
                                triggers="click"
                                popoverClass="alertDashboardPopover  siteClkPopover"
                                placement="right"
                                [ngbPopover]="alertIDPopover"
                              >
                                <ng-template #alertIDPopover>
                                  <li
                                    class="dropdown-menu show right"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    {{ row.alertID }}
                                  </li>
                                </ng-template>
                                {{ row.alertID }}
                              </td>
                              <td
                                class="text-center text-truncate"
                                title="{{ row.alertStartedAt }}"
                              >
                                {{ row.alertStartedAt }}
                              </td>
                              <td class="text-center">
                                <span
                                  class="severity btn"
                                  [ngClass]="{
                                    'btn-outline-danger':
                                      row.severity == 'Sev 1',
                                    'btn-outline-warning':
                                      row.severity == 'Sev 2',
                                    'btn-outline-primary':
                                      row.severity == 'Sev 3'
                                  }"
                                  >{{ row.severity }}</span
                                >
                              </td>
                              <td
                                class="text-truncate"
                                (dblclick)="copyData(row.product)"
                                title="{{ row.product }}"
                              >
                                {{ row.product }}
                              </td>
                              <td
                                class="text-truncate"
                                container="body"
                                (dblclick)="copyData(row.description)"
                                title="{{ row.description }}"
                                container="body"
                                triggers="click"
                                popoverClass="alertDashboardPopover  siteClkPopover"
                                placement="right"
                                [ngbPopover]="alertDescPopover"
                                [ngClass]="{ disabledCheckDone: row.disabledCheckDone }"
                                [style.background-color]="
                                  row.disabledCheckDone ? getForwardedColor() : ''
                                "
                              >
                                <ng-template #alertDescPopover>
                                  <li
                                    (mousemove)="copySelectedText($event)"
                                    class="dropdown-menu show right"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    {{ row.idenNo }}
                                  </li>
                                </ng-template>
                                {{ row.description }}
                              </td>
                              <td
                                class="text-truncate"
                                container="body"
                                (dblclick)="copyData(row.uniqueValue)"
                                title="{{ row.uniqueValue }}"
                                triggers="click"
                                popoverClass="alertDashboardPopover  siteClkPopover"
                                placement="right"
                                [ngbPopover]="alertsourcePopover"
                              >
                                <ng-template #alertsourcePopover>
                                  <li
                                    class="dropdown-menu show right"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    {{ row.uniqueValue }}
                                  </li>
                                </ng-template>
                                {{ row.uniqueValue }}
                              </td>
                              <td
                                class="text-truncate"
                                (dblclick)="copyData(row.sender)"
                                container="body"
                                title="{{ row.sender }}"
                                triggers="click"
                                popoverClass="alertDashboardPopover  siteClkPopover"
                                placement="right"
                                [ngbPopover]="alertsenderPopover"
                              >
                                <ng-template #alertsenderPopover>
                                  <li
                                    class="dropdown-menu show right"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    {{ row.sender }}
                                  </li>
                                </ng-template>
                                {{ row.sender }}
                              </td>
                              <td
                                class="text-center text-truncate"
                                title="{{ row.countForSeverity }}"
                              >
                                {{ row.count }}
                              </td>
                              <td
                                class="text-center text-truncate"
                                title="{{ row.howerCount }}"
                              >
                                {{ row.duration }}
                              </td>
                              <td
                                class="text-center text-truncate"
                                title="{{ row.lastUpdatedAt }}"
                              >
                                {{ row.lastUpdatedAt }}
                              </td>
                              <td
                                class="text-center text-truncate"
                                title="{{ row.viewedBy }}"
                              >
                                @if(!row.viewedBy || row.viewedBy == ''){
                                <div>
                                  <button
                                    class="btn btn-info btn-round btn-sm mx-1"
                                    (click)="viewBy(row)"
                                  >
                                    Ack
                                  </button>
                                </div>
                                } @if(row.viewedBy && row.viewedBy != ''){
                                <div
                                  class="text-truncate"
                                  (dblclick)="copyData(row.viewedBy)"
                                  title="Acknowledged By: {{
                                    row.viewedBy
                                  }} &#010;Acknowledged At: {{ row.viewedAt }}"
                                >
                                  {{ row.viewedBy }}
                                </div>
                                }
                              </td>
                              <td
                                class="text-center text-truncate"
                                title="{{ row.isEscalated }}"
                              >
                                {{ row.isEscalated }}
                              </td>
                              <td
                                class="text-truncate"
                                title="{{ row.lastActionAt }}"
                              >
                                {{ row.lastActionAt }}
                              </td>
                              <td
                                class="text-truncate table-hover"
                                (dblclick)="copyData(row.recentComment)"
                                title="{{ row.recentComment }}"
                                container="body"
                                triggers="click"
                                popoverClass="alertDashboardPopover  siteClkPopover"
                                placement="left"
                                [ngbPopover]="alertPopover"
                              >
                                <ng-template #alertPopover>
                                  <li
                                    class="dropdown-menu show right"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    {{ row.recentComment }}
                                  </li>
                                </ng-template>
                                {{ row.recentComment }}
                              </td>

                              <td class="text-center">
                                <i
                                  class="fn-global-info-o blue cursor-pointer mr-5"
                                  (click)="infoDetails(row)"
                                >
                                </i>
                                <i
                                  class="fn-global-more cursor-pointer font-weight-600"
                                  [animation]="false"
                                  container="body"
                                  triggers="click"
                                  popoverClass="alertDashboardPopover  siteClkPopover"
                                  placement="left"
                                  [ngbPopover]="alertPopoverContent"
                                >
                                </i>
                                <ng-template #alertPopoverContent>
                                  <ul
                                    class="dropdown-menu show right"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="commentsAlert(row)"
                                        ><img
                                          src="assets/images/comment.svg"
                                          alt=""
                                          srcset=""
                                        />
                                        Comment</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="forwardDetails(row)"
                                        ><img
                                          src="assets/images/forward.svg"
                                          alt=""
                                          srcset=""
                                        />
                                        Forward</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="mailDetails(row)"
                                        ><img
                                          src="assets/images/Mail.svg"
                                          alt=""
                                          srcset=""
                                        />
                                        Mail</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="resolveDetails(row)"
                                        ><img
                                          src="assets/images/resolve.svg"
                                          alt=""
                                          srcset=""
                                        />
                                        Resolve</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="
                                          disablePage
                                            ? enable(row)
                                            : disable(row)
                                        "
                                        >@if(disablePage == false){
                                        <img
                                          src="assets/images/disable_dis.svg"
                                        />
                                        } @if(disablePage == true){
                                        <img
                                          src="assets/images/enable_dis.svg"
                                        />
                                        }
                                        {{
                                          disablePage ? "Enable" : "Disable"
                                        }}</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="helpDetails(row)"
                                        ><img
                                          src="assets/images/help_comment.svg"
                                          alt=""
                                          srcset=""
                                        />
                                        Help</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="historyDetails(row)"
                                        ><img
                                          src="assets/images/history_Filled.svg"
                                          alt="History Icon"
                                          srcset=""
                                        />
                                        History</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="changeSeverityDetails(row)"
                                        ><img
                                          src="assets/images/refresh_circle.svg"
                                          alt=""
                                          srcset=""
                                        />
                                        Change Severity</a
                                      >
                                    </li>
                                  </ul>
                                </ng-template>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <fn-pagination
                            class="escalation-pagination"
                            [currentPage]="paginationMap.currentPage"
                            [totalPage]="paginationMap.totalSize"
                            [pageSize]="paginationMap.pageSize"
                            (changePage)="paginzationEvent($event)"
                          ></fn-pagination>
                        </div>
                        @if(this.newFilterData.length >0){
                        <div class="col-md-6 d-flex justify-content-end mt-10">
                          <button
                            class="btn btn-primary btn-round btn-sm mx-1"
                            (click)="commentsAlertDetails()"
                          >
                            Comment
                          </button>
                          <button
                            class="btn btn-primary btn-round btn-sm mx-1"
                            (click)="viewAllDetails()"
                          >
                            Acknowledge All
                          </button>
                          <button
                            class="btn btn-warning btn-round btn-sm mx-1"
                            (click)="forwardAllDetails()"
                          >
                            Forward All
                          </button>
                          <button
                            class="btn btn-danger btn-round btn-sm mx-1"
                            (click)="resolveAllDetails()"
                          >
                            Resolve All
                          </button>
                          <button
                            class="btn btn-round btn-sm mx-1"
                            [ngClass]="disablePage ? 'btn-success' : 'btn-dark'"
                            (click)="disablePage ? enableAll() : disableAll()"
                          >
                            {{ disablePage ? "Enable All" : "Disable All" }}
                          </button>
                        </div>
                        }@if(this.newFilterData.length == 0){
                        <fn-no-data-box
                          [showImg]="true"
                          [imgContainerheight]="'500'"
                          [isVerticalImg]="false"
                        ></fn-no-data-box>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
